/**
 * 判断平台是否是android
 */
export function isAndroid() {
    const u = navigator.userAgent
    const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1
    return isAndroid
}

/**
 * 判断平台是否是iOS
 */
export function isIOS() {
    const u = navigator.userAgent
    const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
    return isiOS
}

/**
 * 微信中打开
 */
export function isInWeChart() {
    const u = navigator.userAgent.toLowerCase()
    return u.indexOf('micromessenger') > -1
}